import { createContext } from 'react';

import RootStore from '../stores/RootStore';

export default createContext<RootStore | undefined>(undefined);
